import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "./../../utils/utils";

export const fetchUser = createAsyncThunk(
  "fetchUser",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/user/list.php";
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.user;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchUserSearch = createAsyncThunk(
  "fetchUserSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/user/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.user;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchUserEdit = createAsyncThunk(
  "fetchUserEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/user/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.user[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveUser = createAsyncThunk("saveUser", async (data, thunkAPI) => {
  const url = process.env.REACT_APP_API_URL + "/controller/user/create.php";
  const authorization = getToken();
  const options = {
    method: "post",
    headers: {
      Authorization: "Bearer " + authorization,
      "Content-Type": "multipart/form-data",
    },
    url,
    data: data,
  };
  const response = await axios(options)
    .then((result) => {
      if (result.data) {
        if (result.data.user) return result.data.user;
        else return result.data.message;
      } else {
        return "Error";
      }
    })
    .catch((error) => {
      return error.code;
    });

  return response;
});

export const editUser = createAsyncThunk("editUser", async (data, thunkAPI) => {
  const url = process.env.REACT_APP_API_URL + "/controller/user/update.php";
  const authorization = getToken();
  const options = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + authorization,
      "Content-Type": "multipart/form-data",
    },
    url,
    data: data,
  };
  const response = await axios(options)
    .then((result) => {
      if (result.data) {
        if (result.data.user) return result.data.user;
        else return result.data.message;
      }
    })
    .catch((error) => {
      return error.code;
    });

  return response;
});

export const deleteUser = createAsyncThunk(
  "deleteUser",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/user/delete.php?id=" + id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
